import { ProjectModel } from '../model/project.model';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { AddCodingArticleProcessor } from '../components/article/processor/add-coding-article.processor';
import { ProjectArticleService } from './project-article.service';
import { Injectable } from '@angular/core';
import { DetachArticleUsageService } from './detach-article-usage.service';
import { ApplicationRefreshService } from '@services/application-refresh.service';

@Injectable({providedIn: 'root'})
export class DetachArticleUsageServiceInitializer {
  constructor(
    private projectModel: ProjectModel,
    private containerService: ContainerService,
    private addCodingArticleProcessor: AddCodingArticleProcessor,
    private projectArticleService: ProjectArticleService,
    private detachArticleUsageService: DetachArticleUsageService,
    private applicationRefreshService: ApplicationRefreshService
  ) {}

  public initialize() {
    this.detachArticleUsageService.initialize(
      this.projectModel,
      this.containerService,
      this.addCodingArticleProcessor,
      this.projectArticleService,
      this.applicationRefreshService
    );
  }
}
